import * as serviceWorker from './serviceWorker';
import React from 'react';
import ReactDOM from 'react-dom';
import App from 'App';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

// redux / saga
import { Provider } from 'react-redux';
import store from 'store';

// material-ui
import theme from 'assets/theme';
import { MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

// components
import SiteVisualData from 'components/SiteVisualData';

// helpers
import NamesListFacebookPixel from 'tracking/NamesListFacebookPixel';

const queryClient = new QueryClient();

ReactDOM.render(
  <>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <Provider store={store}>
          <MuiThemeProvider theme={theme}>
            <SiteVisualData>
              <CssBaseline />
              <App />
              <NamesListFacebookPixel />
            </SiteVisualData>
          </MuiThemeProvider>
        </Provider>
      </QueryClientProvider>
    </BrowserRouter>
  </>,

  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA

serviceWorker.unregister();
